import Control from "ol/control/Control";
import {
  DIRECTIONAL_OPACITY,
  SPEED_OPACITY,
  SPEED_BREAKPOINTS,
} from "../layers/DirectionalLayers";
import { MOTION_COLOR, MOTION_OPACITY } from "../layers/DirectionalMotion";
import { speedGradient } from "../layers/style/util/colorScale";

export class DirectionalHeatmapControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};
    const element = document.createElement("div");
    super({
      element: element,
      target: options.target,
    });
    const this_ = this;

    element.className = "directional-control ol-unselectable ol-control";

    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.className = "heatmap-checkbox";
    checkbox.id = "heatmap-input";
    checkbox.checked = false;

    const label = document.createElement("label");
    label.htmlFor = "heatmap-input";
    label.className = "heatmap-text";
    label.innerText = "FCD";

    checkbox.addEventListener("change", function () {
      this_.set("heatmapToggle", checkbox.checked);
    });
    this_.set("heatmapToggle", checkbox.checked);

    let _pendingDirections = null;

    function updateActiveDirections() {
      const layers = this_.get("directionalLayers");
      if (!layers) return;
      const active = [];
      layers.forEach(function (layer, id) {
        if (layer.getOpacity() > 0) active.push(id);
      });
      this_.set("activeDirections", active.join(","));
    }

    this.restoreState = function (fcdToggle, fcdMode, fcdDirs) {
      if (fcdToggle) {
        checkbox.checked = true;
        this_.set("heatmapToggle", true);
      }
      if (fcdMode === "speed") {
        speedRadio.checked = true;
        onModeChange();
      } else if (fcdMode === "motion") {
        motionRadio.checked = true;
        onModeChange();
      }
      if (fcdDirs) {
        _pendingDirections = fcdDirs;
      }
    };

    const modeContainer = document.createElement("div");

    const densityRadio = document.createElement("input");
    densityRadio.type = "radio";
    densityRadio.name = "fcd-mode";
    densityRadio.id = "fcd-mode-density";
    densityRadio.value = "density";
    densityRadio.checked = true;
    const densityLabel = document.createElement("label");
    densityLabel.htmlFor = "fcd-mode-density";
    densityLabel.innerText = "Density";

    const speedRadio = document.createElement("input");
    speedRadio.type = "radio";
    speedRadio.name = "fcd-mode";
    speedRadio.id = "fcd-mode-speed";
    speedRadio.value = "speed";
    const speedLabel = document.createElement("label");
    speedLabel.htmlFor = "fcd-mode-speed";
    speedLabel.innerText = "Speed";

    const motionRadio = document.createElement("input");
    motionRadio.type = "radio";
    motionRadio.name = "fcd-mode";
    motionRadio.id = "fcd-mode-motion";
    motionRadio.value = "motion";
    const motionLabel = document.createElement("label");
    motionLabel.htmlFor = "fcd-mode-motion";
    motionLabel.innerText = "Motion";

    modeContainer.appendChild(densityRadio);
    modeContainer.appendChild(densityLabel);
    modeContainer.appendChild(speedRadio);
    modeContainer.appendChild(speedLabel);
    modeContainer.appendChild(motionRadio);
    modeContainer.appendChild(motionLabel);

    const speedLegend = document.createElement("div");
    speedLegend.style.cssText =
      "display:none; flex-direction:column; margin-left:4px; padding-top:4px;";

    const legendWrapper = document.createElement("div");
    legendWrapper.style.cssText = "display:flex; align-items:stretch;";

    const gradientBar = document.createElement("div");
    gradientBar.style.cssText =
      "width:10px; height:140px;" +
      "background: " +
      speedGradient("to top", SPEED_BREAKPOINTS) +
      ";";

    const legendLabels = document.createElement("div");
    legendLabels.style.cssText =
      "position:relative; margin-left:2px; font-size:9px;" +
      " height:140px; width:1.6em;";
    const minSpeed = SPEED_BREAKPOINTS[0];
    const maxSpeed = SPEED_BREAKPOINTS[SPEED_BREAKPOINTS.length - 1];
    const speedRange = maxSpeed - minSpeed;
    SPEED_BREAKPOINTS.forEach(function (speed, i) {
      const topPct = ((maxSpeed - speed) / speedRange) * 100;
      const span = document.createElement("span");
      span.style.cssText =
        "position:absolute; left:0;" +
        " top:" +
        topPct.toFixed(2) +
        "%; transform:translateY(-50%);";
      span.innerText = i === SPEED_BREAKPOINTS.length - 1 ? speed + "+" : speed;
      legendLabels.appendChild(span);
    });

    const legendUnit = document.createElement("div");
    legendUnit.style.cssText =
      "font-size:9px; text-align:center; margin-top:2px;";
    legendUnit.innerText = "km/h";

    legendWrapper.appendChild(gradientBar);
    legendWrapper.appendChild(legendLabels);
    speedLegend.appendChild(legendWrapper);
    speedLegend.appendChild(legendUnit);

    const modeOpacity = {
      density: DIRECTIONAL_OPACITY,
      speed: SPEED_OPACITY,
      motion: MOTION_OPACITY,
    };
    function currentOpacity() {
      return modeOpacity[this_.get("displayMode")];
    }

    function wheelFill(mode, i) {
      if (mode === "speed") return "#808080";
      if (mode === "motion") return MOTION_COLOR;
      return originalFills[i];
    }

    function onModeChange() {
      const mode = [densityRadio, speedRadio, motionRadio].find(
        (radio) => radio.checked,
      ).value;
      this_.set("displayMode", mode);
      speedLegend.style.display = mode === "speed" ? "flex" : "none";
      const opacity = modeOpacity[mode];
      [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].forEach(function (i) {
        wheel
          .getElementById("svg-" + i)
          .setAttribute("fill", wheelFill(mode, i));
      });
      const layers = this_.get("directionalLayers");
      if (layers) {
        layers.forEach(function (layer) {
          if (layer.getOpacity() > 0) {
            layer.setOpacity(opacity);
          }
        });
      }
    }
    densityRadio.addEventListener("change", onModeChange);
    speedRadio.addEventListener("change", onModeChange);
    motionRadio.addEventListener("change", onModeChange);
    this_.set("displayMode", "density");

    const wheel = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    wheel.style.display = "block";
    wheel.setAttribute("width", 150);
    wheel.setAttribute("heigth", 150);
    wheel.innerHTML = `
       <g transform="translate(80,80) rotate(90)">
        <circle id="svg-1" fill="#FFFF00" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(-43.10070037841797,0)"></circle>
        <circle id="svg-2" fill="#FF8000" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(-37.32630144861153,-21.55035018920898)"></circle>
        <circle id="svg-3" fill="#FF0000" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(-21.550350189208988,-37.326301448611524)"></circle>
        <circle id="svg-4" fill="#FF0080" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(-2.639156737971934e-15,-43.10070037841797)"></circle>
        <circle id="svg-5" fill="#FF00FF" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(21.550350189208974,-37.32630144861153)"></circle>
        <circle id="svg-6" fill="#8000FF" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(37.32630144861153,-21.55035018920898)"></circle>
        <circle id="svg-7" fill="#0000FF" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(43.10070037841797,-5.278313475943868e-15)"></circle>
        <circle id="svg-8" fill="#0080FF" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(37.326301448611524,21.550350189208988)"></circle>
        <circle id="svg-9" fill="#00FFFF" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(21.550350189209002,37.326301448611524)"></circle>
        <circle id="svg-10" fill="#00FF80" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(7.917470213915802e-15,43.10070037841797)"></circle>
        <circle id="svg-11" fill="#00FF00" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(-21.550350189208988,37.326301448611524)"></circle>
        <circle id="svg-12" fill="#80FF00" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(-37.32630144861152,21.550350189209002)"></circle>
        <text refx="50%" refy="50%" id="select-clear-svg" class="select-clear" transform="rotate(-90)" style="text-anchor: middle;">Clear All</text>
        <text id="N-pole-svg" class="pole" transform="translate(-66.99347993601923,0) rotate(-90)" style="text-anchor: middle;">N</text>
        <text id="E-pole-svg" class="pole" transform="translate(-4.102167538369419e-15,-66.99347993601923) rotate(-90)" style="text-anchor: middle;">E</text>
        <text id="S-pole-svg" class="pole" transform="translate(66.99347993601923,-8.204335076738838e-15) rotate(-90)" style="text-anchor: middle;">S</text>
        <text id="W-pole-svg" class="pole" transform="translate(1.2306502615108255e-14,66.99347993601923) rotate(-90)" style="text-anchor: middle;">W</text>
      </g>`;

    function buttonCleared(button) {
      button.setAttribute("fill-opacity", 0.2);
      button.setAttribute("stroke-width", 0);
    }
    function buttonSelected(button) {
      button.setAttribute("fill-opacity", 1);
      button.setAttribute("stroke-width", 2);
    }
    function toggleDirectionalHeatmap(button) {
      const layer = button._layer;
      if (layer.getOpacity() > 0) {
        layer.setOpacity(0);
        buttonCleared(button);
      } else {
        layer.setOpacity(currentOpacity());
        buttonSelected(button);
      }
      updateActiveDirections();
    }
    [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].forEach(function (i) {
      const button = wheel.getElementById("svg-" + i);
      button.addEventListener(
        "click",
        toggleDirectionalHeatmap.bind(null, button),
        false,
      );
    });

    const originalFills = {};
    [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].forEach(function (i) {
      originalFills[i] = wheel.getElementById("svg-" + i).getAttribute("fill");
    });

    const wheelRow = document.createElement("div");
    wheelRow.style.cssText = "display:flex; align-items:flex-start;";
    wheelRow.appendChild(wheel);
    wheelRow.appendChild(speedLegend);

    this.on("propertychange", function (e) {
      const buttons = [];
      function selectClear(el, buttons, directionalLayers) {
        if (el.textContent == "Clear All") {
          for (const id of directionalLayers.keys()) {
            directionalLayers.get(id).setOpacity(0);
          }
          buttons.forEach((button) => buttonCleared(button));
          el.textContent = "Select All";
        } else {
          for (const id of directionalLayers.keys()) {
            directionalLayers.get(id).setOpacity(currentOpacity());
          }
          buttons.forEach((button) => buttonSelected(button));
          el.textContent = "Clear All";
        }
        updateActiveDirections();
      }
      if (e.key === "zoom") {
        const zoom = e.target.get("zoom");
        if (zoom >= 17) {
          this_.set("active", true);
        } else {
          this_.set("active", false);
        }
      }

      const layers = this_.get("directionalLayers");
      if (layers !== undefined) {
        layers.forEach(function (layer, i) {
          const button = wheel.getElementById("svg-" + i);
          buttons.push(button);

          if (this_.get("heatmapToggle") === false) {
            layer.setVisible(false);
          } else {
            layer.setVisible(true);
            layer.changed();
          }
          button._layer = layer;
          layer.getSource().on("imageloadstart", () => {
            button.setAttribute("stroke", "white");
          });
          layer.on("rendercomplete", () => {
            button.setAttribute("stroke", "black");
          });
          layer.getSource().on("imageloaderror", () => {
            button.setAttribute("stroke", "red");
          });
          layer.on("change", () => {
            button.setAttribute("stroke", "black");
          });
        });
      }
      if (_pendingDirections && layers) {
        const opacity = currentOpacity();
        const activeSet = new Set(_pendingDirections);
        layers.forEach(function (layer, id) {
          const button = wheel.getElementById("svg-" + id);
          if (!activeSet.has(id)) {
            layer.setOpacity(0);
            buttonCleared(button);
          } else {
            layer.setOpacity(opacity);
          }
        });
        _pendingDirections = null;
        updateActiveDirections();
      } else if (layers && this_.get("displayMode") !== "density") {
        const opacity = currentOpacity();
        layers.forEach(function (layer) {
          if (layer.getOpacity() > 0) {
            layer.setOpacity(opacity);
          }
        });
      }

      if (this_.get("active")) {
        label.style.color = "black";
        wheel.style.opacity = "100%";
      } else {
        label.style.color = "grey";
        wheel.style.opacity = "20%";
      }

      // Clear all, select all
      const selectClearButton = wheel.getElementById("select-clear-svg");
      selectClearButton.addEventListener(
        "click",
        selectClear.bind(
          null,
          selectClearButton,
          buttons,
          this_.get("directionalLayers"),
        ),
        false,
      );
      element.appendChild(checkbox);
      element.appendChild(label);
      element.appendChild(modeContainer);
      element.appendChild(wheelRow);
    });
  }
}
